export default __webpack_public_path__ + "static/media/236.5508045e.svg";